import React from "react";
import style from "./style.module.scss";

export default function Results(props) {
  const { rows, className, ...rest } = props;
  return (
    <div className={`${style.results} ${className || ""}`} {...rest}>
      {rows.map((__row, __row_i) => (
        <div key={`result-${__row_i}`} data-type={__row.type} className={style.row}>
          <span>{__row.label}</span>
          <span data-nowrap={__row.nowrap ? "true" : undefined}>{__row.value}</span>
        </div>
      ))}
    </div>
  );
}
